import React, { useState } from "react";
import { Box, Typography, Button, Link } from "@mui/material";
import { motion } from "framer-motion";

const cardData = [
   {
        title: "Conference: SCOPE 14th Annual – February 6-9, 2023",
        text: "In the realm of clinical trials, data holds immense value. Timely access to accurate and comprehensive data is crucial for making informed decisions that can drive trial success. Clinical Trial Management Systems (CTMS) play a vital role in facilitating real-time data access, enabling researchers and stakeholders to make data-driven decisions. In this article, we will […].",
        img: "/news1.png",
        bgColor: "#a0e7f7ff"
    },
    {
        title: "Conference: SCOPE 14th Annual – February 6-9, 2023",
        text: "In the realm of clinical trials, data holds immense value. Timely access to accurate and comprehensive data is crucial for making informed decisions that can drive trial success. Clinical Trial Management Systems (CTMS) play a vital role in facilitating real-time data access, enabling researchers and stakeholders to make data-driven decisions. In this article, we will […].",
        img: "/news1.png",
        bgColor: "#d7ef78ff"
    },
    {
        title: "Conference: SCOPE 14th Annual – February 6-9, 2023",
        text: "In the realm of clinical trials, data holds immense value. Timely access to accurate and comprehensive data is crucial for making informed decisions that can drive trial success. Clinical Trial Management Systems (CTMS) play a vital role in facilitating real-time data access, enabling researchers and stakeholders to make data-driven decisions. In this article, we will […].",
        img: "/news1.png",
        bgColor: "#6fc4ebff"
    },
     {
        title: "Conference: SCOPE 14th Annual – February 6-9, 2023",
        text: "In the realm of clinical trials, data holds immense value. Timely access to accurate and comprehensive data is crucial for making informed decisions that can drive trial success. Clinical Trial Management Systems (CTMS) play a vital role in facilitating real-time data access, enabling researchers and stakeholders to make data-driven decisions. In this article, we will […].",
        img: "/news1.png",
        bgColor: "#a1f7a7ff"
    },
    {
        title: "Conference: SCOPE 14th Annual – February 6-9, 2023",
        text: "In the realm of clinical trials, data holds immense value. Timely access to accurate and comprehensive data is crucial for making informed decisions that can drive trial success. Clinical Trial Management Systems (CTMS) play a vital role in facilitating real-time data access, enabling researchers and stakeholders to make data-driven decisions. In this article, we will […].",
        img: "/news1.png",
        bgColor: "#d7ef78ff"
    },
    {
        title: "Conference: SCOPE 14th Annual – February 6-9, 2023",
        text: "In the realm of clinical trials, data holds immense value. Timely access to accurate and comprehensive data is crucial for making informed decisions that can drive trial success. Clinical Trial Management Systems (CTMS) play a vital role in facilitating real-time data access, enabling researchers and stakeholders to make data-driven decisions. In this article, we will […].",
        img: "/news1.png",
        bgColor: "#6fc4ebff"
    },
     {
        title: "Conference: SCOPE 14th Annual – February 6-9, 2023",
        text: "In the realm of clinical trials, data holds immense value. Timely access to accurate and comprehensive data is crucial for making informed decisions that can drive trial success. Clinical Trial Management Systems (CTMS) play a vital role in facilitating real-time data access, enabling researchers and stakeholders to make data-driven decisions. In this article, we will […].",
        img: "/news1.png",
        bgColor: "#8fbbf5ff"
    },
    {
        title: "Conference: SCOPE 14th Annual – February 6-9, 2023",
        text: "In the realm of clinical trials, data holds immense value. Timely access to accurate and comprehensive data is crucial for making informed decisions that can drive trial success. Clinical Trial Management Systems (CTMS) play a vital role in facilitating real-time data access, enabling researchers and stakeholders to make data-driven decisions. In this article, we will […].",
        img: "/news1.png",
        bgColor: "#d7ef78ff"
    },
    {
        title: "Conference: SCOPE 14th Annual – February 6-9, 2023",
        text: "In the realm of clinical trials, data holds immense value. Timely access to accurate and comprehensive data is crucial for making informed decisions that can drive trial success. Clinical Trial Management Systems (CTMS) play a vital role in facilitating real-time data access, enabling researchers and stakeholders to make data-driven decisions. In this article, we will […].",
        img: "/news1.png",
        bgColor: "#6fc4ebff"
    }
];

export default function MotionCards() {
  const [page, setPage] = useState(0);
  const itemsPerPage = 5;

  const startIndex = page * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = cardData.slice(startIndex, endIndex);

  const handleNext = () => {
    if (endIndex < cardData.length) {
      setPage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (page > 0) {
      setPage((prev) => prev - 1);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4, p: 4 }}>
      {currentData.map((card, index) => {
        const isEven = index % 2 === 0;

        return (
          <motion.div
            key={startIndex + index}
            initial={{ opacity: 0, x: isEven ? 100 : -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.3 }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: isEven ? "row" : "row-reverse",
                alignItems: "center",
                gap: 3,
                backgroundColor: card.bgColor,
                borderRadius: 3,
                p: 3,
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                minHeight: 200
              }}
            >
              {/* Image */}
              <Box
                component="img"
                src={card.img}
                alt={card.title}
                sx={{
                  width: 500,
                  height: 250,
                  borderRadius: 2,
                  objectFit: "cover",
                  flexShrink: 0
                }}
              />

              {/* Text */}
              <Box>
                <Link
                href="#"
                underline="none"
                sx={{
                  display: "block",
                  fontSize: { xs: "1.05rem", md: "1.25rem" },
                  fontWeight: 500,
                  color: "#0083efff",
                  mb: 1,
                  "&:hover": { textDecoration: "underline" }
                }}
              >
                  {card.title}
               </Link>
                <Typography variant="body1" color="white">{card.text}</Typography>
              </Box>
            </Box>
          </motion.div>
        );
      })}

      {/* Pagination Buttons */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
        <Button
          variant="contained"
          onClick={handlePrev}
          disabled={page === 0}
        >
          Newer
        </Button>
        <Button
          variant="contained"
          onClick={handleNext}
          disabled={endIndex >= cardData.length}
        >
          Older
        </Button>
      </Box>
    </Box>
  );
}
